import { MappingComponent } from '@/components/mappings';

export const MappingPage = () => {
  return <MappingComponent />;
};
